"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var OtpFields = function (_a) {
    var style = _a.style, children = _a.children, tabIndex = _a.tabIndex;
    return (react_1.default.createElement("div", { style: style, tabIndex: tabIndex }, children));
};
var OTPInput = function (_a) {
    var _b, _c;
    var fieldCount = _a.fieldCount, focusIndex = _a.focusIndex, inputStyle = _a.inputStyle, wrapperStyle = _a.wrapperStyle, onChange = _a.onChange, fontSize = _a.fontSize, handleFocus = _a.handleFocus, handleBlur = _a.handleBlur, includeLetters = _a.includeLetters;
    var emptyArray = Array.apply(null, Array(fieldCount));
    var inputsInitial = emptyArray.map(function (_item, i) { return ({ autoFocus: i === focusIndex, key: "otp" + i }); });
    var _d = (0, react_1.useState)(inputsInitial), inputs = _d[0], setInputs = _d[1];
    var refsCollection = {};
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    (0, react_1.useEffect)(function () {
        refsCollection["otp" + (focusIndex !== null && focusIndex !== void 0 ? focusIndex : 0)].focus();
    }, []);
    var inputStyleInitial = {
        width: fontSize + "px",
        height: 'auto',
        align: 'center',
        margin: fontSize / 5 + "px",
        lineHeight: fontSize * 1.1 + "px",
        borderBottom: ("1px solid " + ((_b = themeContext.colors) === null || _b === void 0 ? void 0 : _b.darkestgrey)),
        padding: '0px',
        paddingLeft: fontSize / 5 + "px",
        borderRadius: '0',
        fontFamily: 'Roboto-Mono, monospace',
        fontSize: fontSize + "px",
        fontWeight: 'bold',
        color: (_c = themeContext.colors) !== null && _c !== void 0 ? _c : themeContext.colors.darkestgrey,
        backgroundColor: 'transparent'
    };
    var wrapperStyleInitial = {
        display: 'inline-flex',
        justifyContent: 'center',
        backgroundColor: 'white',
        borderRadius: '5px',
        padding: fontSize * 0.3 + "px " + fontSize * 0.6 + "px"
    };
    var onBlur = function (e) {
        var focused = Object.values(refsCollection).reduce(function (cumulative, ref) { var _a; return ((_a = ref === document.activeElement) !== null && _a !== void 0 ? _a : cumulative); }, false);
        if (!focused) {
            handleBlur === null || handleBlur === void 0 ? void 0 : handleBlur(e);
        }
    };
    var handleChange = function (_item, i) { return function (e) {
        var value = e.target.value;
        var valid = (includeLetters ? /^[a-zA-Z0-9]+$/ : /^\d+$/).test(value);
        if (!valid) {
            refsCollection["otp" + i].value = '';
            var otpCode_1 = Object.values(refsCollection).map(function (ref) { return ref.value; }).join('');
            onChange(otpCode_1);
            return;
        }
        if (value.length === 1) {
            var newInputsState = __spreadArray([], inputs, true);
            if (i !== newInputsState.length - 1) {
                refsCollection["otp" + (i + 1)].focus();
            }
            setInputs(newInputsState);
        }
        else if (value.length > 1) {
            refsCollection["otp" + i].value = value[0];
            if (refsCollection["otp" + (i + 1)]) {
                refsCollection["otp" + (i + 1)].focus();
                refsCollection["otp" + (i + 1)].value = value[1];
            }
            if (refsCollection["otp" + (i + 2)]) {
                refsCollection["otp" + (i + 2)].focus();
            }
        }
        var otpCode = Object.values(refsCollection).map(function (ref) { return ref.value; }).join('');
        onChange(otpCode);
    }; };
    var handlePaste = function (_, i) { return function (e) {
        e.preventDefault();
        var pasteText = e.clipboardData.getData('Text');
        var valid = (includeLetters ? /^[a-zA-Z0-9]+$/ : /^\d+$/).test(pasteText);
        if (!valid) {
            return;
        }
        var pasteTextFits = (inputs.length - pasteText.length) >= i;
        if (pasteText.length === fieldCount) {
            var refsArray = Object.values(refsCollection);
            refsArray.forEach(function (item, index) {
                item.value = pasteText.charAt(index);
            });
        }
        else if (pasteTextFits) {
            var refsArray = Object.values(refsCollection);
            var fromCurrent = refsArray.slice(i, refsArray.length);
            fromCurrent.forEach(function (item, index) {
                item.value = pasteText.charAt(index);
            });
        }
        var otpCode = Object.values(refsCollection).map(function (ref) { return ref.value; }).join('');
        onChange(otpCode);
    }; };
    var setCaretPosition = function (element, caretPos) {
        var elem = element;
        if (elem != null) {
            if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            }
            else if (elem.selectionStart > -1) {
                elem.selectionStart = caretPos;
                elem.setSelectionRange(caretPos, caretPos);
            }
        }
    };
    var handleKeyDown = function (_item, i) { return function (e) {
        var _a, _b, _c, _d, _e, _f;
        if (e.ctrlKey || e.metaKey) {
            return false;
        }
        var key = (_a = e.keyCode) !== null && _a !== void 0 ? _a : e.charCode;
        var isCapital = e.shiftKey;
        if (key >= 96 && key <= 105) {
            key -= 48;
        }
        var charTyped = isCapital ? String.fromCharCode(key).toUpperCase() : String.fromCharCode(key).toLowerCase();
        var regex = includeLetters ? /^[a-zA-Z0-9]+$/ : /^\d+$/;
        if (charTyped.match(regex) != null) {
            var keydownElement = refsCollection["otp" + i];
            if (keydownElement.value) {
                e.preventDefault();
                keydownElement.value = charTyped;
                (_b = refsCollection["otp" + (i + 1)]) === null || _b === void 0 ? void 0 : _b.focus();
            }
            var otpCode = Object.values(refsCollection).map(function (ref) { return ref.value; }).join('');
            onChange(otpCode);
        }
        else if (key === 39 && ((_c = e.target) === null || _c === void 0 ? void 0 : _c.value.length) === ((_d = e.target) === null || _d === void 0 ? void 0 : _d.selectionEnd) && i < inputs.length - 1) {
            var targetElement_1 = refsCollection["otp" + (i + 1)];
            targetElement_1.focus();
            setTimeout(function () {
                var caretPosition = 0;
                setCaretPosition(targetElement_1, caretPosition);
            }, 0);
        }
        else if (key === 37 && ((_e = e.target) === null || _e === void 0 ? void 0 : _e.selectionEnd) === 0 && i !== 0) {
            var targetElement_2 = refsCollection["otp" + (i - 1)];
            targetElement_2.focus();
            setTimeout(function () {
                var caretPosition = targetElement_2.value.length;
                setCaretPosition(targetElement_2, caretPosition);
            }, 0);
        }
        else if (key === 8 && !((_f = e.target) === null || _f === void 0 ? void 0 : _f.value)) {
            e.preventDefault();
            var newInputsState = __spreadArray([], inputs, true);
            if (i !== 0) {
                refsCollection["otp" + (i - 1)].focus();
                refsCollection["otp" + (i - 1)].value = '';
                newInputsState[i].focus = false;
            }
            setInputs(newInputsState);
            var otpCode = Object.values(refsCollection).map(function (ref) { return ref.value; }).join('');
            onChange(otpCode);
        }
        else if (e.key.length === 1) {
            e.preventDefault();
        }
    }; };
    return (react_1.default.createElement(OtpFields, { style: __assign(__assign({}, wrapperStyleInitial), wrapperStyle), tabIndex: -1 }, inputs.map(function (item, i) { return (react_1.default.createElement("input", { style: __assign(__assign({}, inputStyleInitial), inputStyle), type: includeLetters ? 'text' : 'tel', id: "otp" + i, key: item.key, "aria-label": "OTP Input " + i, name: "otp" + i, maxLength: 2, onBlur: onBlur, onFocus: handleFocus, onPaste: handlePaste(item, i), onChange: handleChange(item, i), onKeyDown: handleKeyDown(item, i), ref: function (instance) { item.key && (refsCollection[item.key] = instance); } })); })));
};
OTPInput.defaultProps = {
    onChange: function () { },
    handleFocus: function () { },
    handleBlur: function () { },
    fieldCount: 6,
    focusIndex: 0,
    inputStyle: {},
    wrapperStyle: {},
    fontSize: 15,
    includeLetters: false
};
exports.default = OTPInput;
//# sourceMappingURL=OTPInput.js.map